// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("@popperjs/core")
require("jquery")
require("@nathanvda/cocoon")

import "bootstrap"
// import "@fortawesome/fontawesome-free/css/all.css";
// import "@awesome.me/kit-6ac5ff4db8/icons/css/all.css";
// import '../../assets/stylesheets/application.scss'
// import 'flatpickr/dist/themes/light.css'
import "swiper/swiper-bundle.css"
import "controllers"
import "@hotwired/turbo-rails"

import { loadingSpinner } from "../helpers"
global.Rails = Rails;
global.$ = jQuery;
global.loadingSpinner = loadingSpinner;

// Import the specific modules you may need (Modal, Alert, etc)
import { Tooltip, Popover } from "bootstrap"

// The stylesheet location we created earlier
// require("../stylesheets/application.scss")

// Scans a root element for Bootstrap tooltip/popover triggers and initializes
// any that don't already have an instance. Safe to call repeatedly.
function initBootstrapOverlays(root = document) {
    if (!root || !root.querySelectorAll) return

    root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(el) {
        if (!Tooltip.getInstance(el)) new Tooltip(el)
    })
    root.querySelectorAll('[data-bs-toggle="popover"]').forEach(function(el) {
        if (!Popover.getInstance(el)) new Popover(el)
    })
}

// Initial page loads
document.addEventListener("turbo:load", function() { initBootstrapOverlays() })

// Turbo Frame renders
document.addEventListener("turbo:frame-load", function(e) { initBootstrapOverlays(e.target) })

// Infinite scroll appends — listen for the custom event dispatched by
// infinite_scroll_controller.js after new items are inserted.
document.addEventListener("infinite-scroll:loaded", function(e) { initBootstrapOverlays(e.target) })

// Turbo Stream renders — wrap the stream's render() so we can init overlays
// on any elements it inserts/replaces. Without this, tooltips added via a
// Turbo Stream (e.g. mark-as-read re-renders a notification partial) never
// get mounted until a full page reload.
document.addEventListener("turbo:before-stream-render", function(e) {
    const originalRender = e.detail.render
    e.detail.render = async function(streamElement) {
        await originalRender(streamElement)
        initBootstrapOverlays()
        cleanupOrphanedTooltips()
    }
})

// Hide the tooltip as soon as its trigger is clicked. Without this, clicking
// a tooltip-bearing element that is then replaced by a Turbo Stream leaves
// the tooltip popup orphaned at document root (no mouseleave fires because
// the trigger is gone).
document.addEventListener("click", function(e) {
    const trigger = e.target && e.target.closest && e.target.closest('[data-bs-toggle="tooltip"]')
    if (!trigger) return
    const instance = Tooltip.getInstance(trigger)
    if (instance) instance.hide()
})

// Sweep any tooltip popups whose trigger element no longer exists in the DOM
// (belt-and-suspenders against turbo stream replacements).
function cleanupOrphanedTooltips() {
    document.querySelectorAll('.tooltip').forEach(function(t) {
        if (!document.querySelector('[aria-describedby="' + t.id + '"]')) t.remove()
    })
}

window.addEventListener('beforeunload', (event) => {
  const confirmDiscardModal = document.querySelector('#confirmDiscardModal');

  if (localStorage.getItem('isShowModal') === 'true' && confirmDiscardModal) {
    event.preventDefault();
  }
});

document.addEventListener('turbo:before-visit', (event) => {
  const confirmDiscardModal = document.querySelector('#confirmDiscardModal');
  if (localStorage.getItem('isShowModal') === 'true' && confirmDiscardModal) {
    event.preventDefault();
    localStorage.setItem('redirectToPath', event.detail.url);
    confirmDiscardModal.click();
  }
});
